import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultOrdersDispatchData, getOrdersDispathById, uploadEwayPdf } from '@/api/orders-dispatches';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import { Action } from 'vuex-module-decorators';
import router from '@/router';
import { AdminModule } from '@/store/modules/admin';
import FileUpload from '@/components/FileUpload/index.vue';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultOrdersDispatchData);
    this.loading = false;
    this.rules = {
      ewayBillUrl: {
        required: true,
        trigger: 'blur',
        message: 'This field is required'
      }
    };
    this.loggedInAdmin = null;
    this.ordersDispatchId = 0;
    this.ewayUpdateFromData = {};
    this.ewayBillUrl = [];
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.ordersDispatchId = +id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultOrdersDispatchData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getOrdersDispathById(id);
      this.formData = data;
      if (data && data.ewayBillUrl) {
        this.ewayBillUrl.push({
          name: 'Eway PDF',
          url: 'https://cdn-icons-png.freepik.com/256/9681/9681223.png' // data.ewayBillUrl,
        });
      }
      // Just for test
      const title = 'Upload E-way PDF - #' + this.formData.id;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title}`;
  }
  submitForm() {
    this.$refs.ewayUpdateFromData.validate(valid => {
      if (valid) {
        this.uploadEwayPdf();
      } else {
        return false;
      }
    });
  }
  async uploadEwayPdf() {
    // upload E-way PDF
    try {
      this.loading = true;
      this.$confirm('Do you want to upload E-way PDF?', 'Upload E-way PDF', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--success',
        cancelButtonText: 'No',
        cancelButtonClass: 'el-button--danger',
        type: 'warning'
      }).then(async () => {
        const updateEWayRequest = {
          id: this.ordersDispatchId,
          ewayBillUrl: this.ewayUpdateFromData.ewayBillUrl,
          ewayBillNo: this.ewayUpdateFromData.ewayBillNo
        };
        const updateEWayResponse = await uploadEwayPdf(updateEWayRequest);
        if (updateEWayResponse && updateEWayResponse.status === 'success') {
          this.$message({
            message: 'E-way PDF uploaded successfully',
            type: 'success'
          });
          router.push('/orders-dispatches/list');
        } else {
          this.$message({
            message: 'Failed to upload E-way PDF',
            type: 'error'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  }
  pdfUploaded(file) {
    this.ewayUpdateFromData.ewayBillUrl = file.response;
  }
  resetForm() {
    this.ewayBillUrl = [];
    if (this.ordersDispatchId) {
      this.fetchData(this.ordersDispatchId);
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "uploadEwayPdf", null);
default_1 = __decorate([Component({
  name: 'OrdersDispatchDetail',
  components: {
    FileUpload
  }
})], default_1);
export default default_1;